import { useEffect, useState } from 'react'

import { hooks } from '../../hooks'
import { BankAccountDetailsPagePayload, BankAccountsDocumentsFilter, BankAccountsHistoryFilter } from '../../types'

const defaultFilter = (id: number): BankAccountDetailsPagePayload => ({
  id,
  historyPage: 1,
  historySize: 10
})

export const useBankAccountDetails = (id: number) => {
  const [filter, setFilter] = useState<BankAccountDetailsPagePayload>(() => defaultFilter(id))

  useEffect(() => {
    setFilter(defaultFilter(id))
  }, [id])

  const { data, isFetching } = hooks.useDetailsPage(filter)

  const onFilterBankAccountDetails = async (payload: BankAccountsDocumentsFilter) => setFilter({ id: id, ...payload })
  const onFilterBankAccountHistory = async (payload: BankAccountsHistoryFilter) => setFilter({ id: id, ...payload })

  return {
    data,
    onFilterBankAccountDetails,
    onFilterBankAccountHistory,
    isFetching
  }
}
